import React from 'react';
import { Modal, message, Row, Table, Space } from 'antd';
import { SettingOutlined, EditOutlined, BellOutlined } from '@ant-design/icons';
import NavItem from '../../../components/nav-item';
import dayjs from 'dayjs';
import { getCurrentShopId }  from '../../shop/get-current-shop';
import SwitchShop from '../../shop/switch-shop';
import usePagination from '../../../components/pagination';

const iconStyle = {
    fontSize: 28,
}

const typeMap = {
    'ONCE': '一次性',
    'CYC': '周期性'
}

const statusMap = {
    0: '草稿',
    2: '等待执行',
    3: '部分执行',
    4: '已执行',
    6: '已取消',
}

export default () => {
    const [plans, setPlans] = React.useState([]);
    const [shopId, setShopId] =  React.useState(null);
    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            fetchPlans(page, pageSize)
        },
    });

     React.useEffect(() => {
        getCurrentShopId().then(res => {
            setShopId(res);
        });
    }, []);

    const columns =  [
        {
            title: '名称',
            dataIndex: 'name',
        },
        {
            title: '类型',
            dataIndex: 'type',
            render: (text, record) => {
                return typeMap[text];
            }
        },
        {
            title: '短信内容',
            width: '340px',
            dataIndex: 'smsContent',
            render:  (r, record) => (
                <div>
                    {`【${r?.signName}】${r?.templateContent}`}
                </div>
            )
        },
        {
            title: '执行数据',
            dataIndex: 'times',
            render:  (t, r) => (
                <div>
                    <div>已执行：{r.sent}/{t}次</div>
                    <div>发送短信：{r.smsCount}条</div>
                </div>
            )
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            render: (text) => (
                <span>{dayjs(text).format('YYYY-MM-DD HH:mm')}</span>
            )
        },
        {
            title: '发送时间',
            dataIndex: 'sendTime',
            render: (text) => (
                <span>{dayjs(text).format('YYYY-MM-DD HH:mm')}</span>
            )
        },
        {
            fixed: 'right',
            title: '状态',
            dataIndex: 'status',
            render: (text) => statusMap[ +text],
        },
        {
            fixed: 'right',
            title: '操作',
            key: 'action',
            render: (text, r) => {
                return <Space size="small">
                    <a href={`/promotion/sms/create-task?action=view&taskId=${r.taskId}&shopId=${shopId}`}>详情</a>
                </Space>
            }
                
        }
    ]

    const fetchPlans = async (page = 1, pageSize = 10) => {
        const shopId = await getCurrentShopId();
        const response = await fetch( `/api/promotion/sms/task/list?shopId=${shopId}&page=${page}&pageSize=${pageSize}`);

        const result = await response.json();

        if(result && result.success) {
            setPlans(result.data.rows);
            setTotal(result.data.count);
        }else {
            message.error(result.message);
        }
    }

    React.useEffect(() => {
        fetchPlans();
    }, []);

    return (
        <div>
            <SwitchShop />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/promotion/sms/config" text="短信通道配置">
                    <SettingOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/promotion/sms/create-task" text="创建计划">
                    <EditOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/promotion/sms/notify-config" text="短信通知配置">
                    <BellOutlined style={iconStyle} />
                </NavItem>
            </Row>
            <h2>短信营销计划列表</h2>
            <Table pagination={pagination} rowKey={'taskId'} size='small' columns={columns} dataSource={plans} scroll={ { x: 'max-content' } } />
        </div>
    )
}